"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const axios_1 = __importDefault(require("axios"));
const Modal_1 = __importDefault(require("../Modal"));
const Button_1 = __importDefault(require("../Button/Button"));
const MoonpayWidget_1 = __importDefault(require("../BuyProvider/MoonpayWidget"));
const SimplexWidget_1 = __importDefault(require("../BuyProvider/SimplexWidget"));
const CEXWidget_1 = __importDefault(require("../BuyProvider/CEXWidget"));
const MercuryoWidget_1 = __importStar(require("../BuyProvider/MercuryoWidget"));
const BanxaWidget_1 = __importDefault(require("../BuyProvider/BanxaWidget"));
const styled_1 = require("./styled");
const UnsupportedWidget_1 = __importDefault(require("./UnsupportedWidget"));
const helpers_1 = __importDefault(require("../BuyProvider/MercuryoWidget/helpers"));
const constants_1 = require("./constants");
const helpers_2 = require("../BuyWidget/helpers");
const TransakWidget_1 = __importDefault(require("../BuyProvider/TransakWidget"));
const BuyModal = ({ modalRef, callback, provider, providerProp, wallet, crypto, locale, email, amount, cryptoAmount, fiat, defaultCrypto = "btc", env = "production", exitText = "Exit", externalTransactionId, }) => {
    const [availableProvider, setAvailableProvider] = (0, react_1.useState)(provider);
    const [widgetCrypto, setWidgetCrypto] = (0, react_1.useState)(crypto);
    (0, react_1.useEffect)(() => {
        const checkProvider = () => __awaiter(void 0, void 0, void 0, function* () {
            // if provider prop passed, providerProp overrides all
            if (providerProp) {
                setAvailableProvider(providerProp);
                return;
            }
            // targeted provider based on getProvider fn in BuyWidget
            if (provider && provider !== "moonpay") {
                setAvailableProvider(provider);
                return;
            }
            // if providerFn defaults to moonpay && providerProp not provided, do region check
            try {
                const { data: { isAllowed, state, alpha2 }, } = yield axios_1.default.get(constants_1.MOONPAY_IP);
                const { hostname } = (window === null || window === void 0 ? void 0 : window.location) || "";
                const isBuyOrSell = hostname === "buy.bitcoin.com" || hostname === "sell.bitcoin.com";
                if (isAllowed) {
                    setAvailableProvider("moonpay");
                }
                else if (!constants_1.CEX_UNSUPPORTED_COUNTRIES.includes(alpha2) &&
                    !constants_1.CEX_UNSUPPORTED_STATES.includes(state)) {
                    setAvailableProvider("cex");
                }
                else if (!constants_1.SIMPLEX_UNSUPPORTED_COUNTRIES.includes(alpha2) &&
                    !constants_1.SIMPLEX_UNSUPPORTED_STATES.includes(state)) {
                    setAvailableProvider("simplex");
                }
                else if (!constants_1.MERCURYO_UNSUPPORTED_COUNTRIES.includes(alpha2) &&
                    !constants_1.MERCURYO_UNSUPPORTED_STATES.includes(state) &&
                    isBuyOrSell) {
                    setAvailableProvider("mercuryo");
                }
                else {
                    setAvailableProvider("unsupported");
                }
            }
            catch (error) {
                setAvailableProvider("unsupported");
            }
        });
        checkProvider();
    }, [provider, providerProp]);
    (0, react_1.useEffect)(() => {
        const url = `${MercuryoWidget_1.MERCURYO_SCRIPTS.url}`;
        (0, helpers_1.default)(url);
    }, [env]);
    (0, react_1.useEffect)(() => {
        if (typeof crypto === "undefined")
            return;
        const cryptoCode = (0, helpers_2.getProviderCode)(crypto, availableProvider);
        setWidgetCrypto(cryptoCode);
    }, [crypto, availableProvider]);
    return (react_1.default.createElement(Modal_1.default, { callback: callback, ref: modalRef, closer: false, disableScroll: provider === "mercuryo" },
        react_1.default.createElement(styled_1.Wrapper, null,
            availableProvider !== "unsupported" && (react_1.default.createElement(styled_1.BuyContainer, null,
                availableProvider === "moonpay" && (react_1.default.createElement(MoonpayWidget_1.default, { wallet: wallet, crypto: widgetCrypto, language: locale, email: email, baseCurrencyAmount: amount, defaultCurrencyCode: defaultCrypto, baseCurrencyCode: fiat, env: env, externalTransactionId: externalTransactionId })),
                availableProvider === "simplex" && (react_1.default.createElement(SimplexWidget_1.default, { env: env, crypto: widgetCrypto, fiat: fiat, amount: amount, lang: locale, externalTransactionId: externalTransactionId, wallet: wallet })),
                availableProvider === "cex" && (react_1.default.createElement(CEXWidget_1.default, { crypto: widgetCrypto, fiat: fiat, fiatValue: amount === null || amount === void 0 ? void 0 : amount.toString(), cryptoAmount: cryptoAmount === null || cryptoAmount === void 0 ? void 0 : cryptoAmount.toString() })),
                availableProvider === "banxa" && (react_1.default.createElement(BanxaWidget_1.default, { crypto: widgetCrypto, fiat: fiat, fiatValue: amount === null || amount === void 0 ? void 0 : amount.toString(), cryptoAmount: cryptoAmount === null || cryptoAmount === void 0 ? void 0 : cryptoAmount.toString() })),
                availableProvider === "mercuryo" && (react_1.default.createElement(MercuryoWidget_1.default, { env: env, crypto: widgetCrypto, fiat: fiat, amount: amount, lang: locale })),
                availableProvider === "transak" && (react_1.default.createElement(TransakWidget_1.default, { env: env, crypto: widgetCrypto, amount: amount, lang: locale })))),
            availableProvider === "unsupported" && (react_1.default.createElement(styled_1.UnsupportedContainer, null,
                react_1.default.createElement(UnsupportedWidget_1.default, null))),
            react_1.default.createElement(styled_1.ButtonContainer, { mercuryo: provider === "mercuryo" },
                react_1.default.createElement(Button_1.default, { design: "secondary", onClick: () => {
                        if (!modalRef || !modalRef.current)
                            return;
                        modalRef.current.close();
                        /* if (provider === "simplex") {
                          modalRef.current.hide();
                        } else {
                        } */
                    } }, exitText)))));
};
exports.default = BuyModal;
//# sourceMappingURL=BuyModal.js.map